import { render } from "./NuwallStock.vue?vue&type=template&id=1beb292b&scoped=true"
import script from "./NuwallStock.vue?vue&type=script&lang=js"
export * from "./NuwallStock.vue?vue&type=script&lang=js"

import "./NuwallStock.vue?vue&type=style&index=0&id=1beb292b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1beb292b"]])

export default __exports__